var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "25px",
    viewBox: "0 0 28 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo short") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "me",
    transform: "translate(-39.000000, -24.000000)",
    fill: "#F4F4F4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-short",
    transform: "translate(39.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3238548,6.97889139 C12.2959512,7.57686298 13.0541153,8.46465471 13.4906506,9.5161565 L13.4906506,0.426966292 L19,0.426966292 L19,24.1937534 L13.4906506,24.1937534 L13.4906506,20.9499081 C13.055159,22.0035673 12.296894,22.8935207 11.3238548,23.4930128 C10.2554729,24.1359736 9.02389688,24.4592984 7.77605666,24.4244139 C6.36843018,24.4461488 4.98455613,24.0618325 3.79138085,23.3178276 C2.582156,22.5318073 1.6206267,21.4214812 1.01764772,20.1148589 C0.31276357,18.5850287 -0.0341199486,16.915798 0.00315336595,15.2330323 C-0.0371762454,13.545288 0.30979661,11.8706343 1.01764772,10.336607 C1.62335188,9.03406425 2.58446913,7.9272491 3.79138085,7.14239754 C4.98537043,6.40023134 6.36868896,6.01606927 7.77605666,6.03581126 C9.02505777,6.0044384 10.2567175,6.33183972 11.3238548,6.97889139 Z M6.69705688,12.0213043 C5.97576898,12.7999051 5.61512504,13.8704811 5.61512504,15.2330323 C5.61512504,16.5955836 5.97576898,17.6661596 6.69705688,18.4447603 C7.43265753,19.228038 8.47381813,19.6542615 9.54995575,19.6126614 C10.6289453,19.6470802 11.6698288,19.2135132 12.4028546,18.424322 C13.147599,17.6320958 13.5189939,16.5722256 13.5170468,15.2447113 C13.5150845,13.9171971 13.1436896,12.8524606 12.4028546,12.0505019 C11.6645714,11.2711006 10.6252624,10.8456351 9.54995575,10.8826008 C8.47837344,10.8334914 7.43792026,11.248777 6.69705688,12.0213043 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "28 19.4269663 28 24.4269663 22 24.4269663 22 19.4269663"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.aa688881922a77ce567036866539dd2e.svg";
export { ForwardRef as ReactComponent };